import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function InfoPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <p className="text-[#536D61]">Η σελίδα δεν βρέθηκε.</p>
      <Link to="/" className="text-[#1E3A2F] underline mt-4 inline-block">Αρχική</Link>
    </div>
  );
  if (!page) return <div className="max-w-3xl mx-auto px-6 py-24 text-center text-[#536D61]">Φόρτωση...</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="font-serif-display text-4xl lg:text-5xl text-[#1E3A2F] mb-8">{page.title}</h1>
      <div className="prose-pharm whitespace-pre-line text-[#2a3a33] leading-relaxed">{page.content}</div>
    </div>
  );
}
